import React from "react";
import { Box, Container, Backdrop, CircularProgress } from "@mui/material";

const LoaderLayout = () => {
  return (
    <Box className="userLayout" style={{ marginTop: "111px" }}>
      <Container
        disableGutters={true}
        maxWidth="lg"
        sx={{ background: "#242743" }}
      >
        <Backdrop
          sx={(theme) => ({
            color: "#fff",
            zIndex: theme.zIndex.drawer + 1,
          })}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>
    </Box>
  );
};

export default LoaderLayout;
